import { render, staticRenderFns } from "./QaBox.vue?vue&type=template&id=76c52b02&scoped=true&"
import script from "./QaBox.vue?vue&type=script&lang=js&"
export * from "./QaBox.vue?vue&type=script&lang=js&"
import style0 from "./QaBox.vue?vue&type=style&index=0&id=76c52b02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c52b02",
  null
  
)

export default component.exports